import { connect } from 'react-redux'
import FlowCreateModal from './FlowCreateModal'
import { push } from 'react-router-redux'
import { createFlow } from 'features/Flows/Flows.actions'

const stateToProps = ({ flows: { createLoading, templates } }) => ({
  templates,
  createLoading,
})

const dispatchToProps = {
  createFlow,
  push,
}

export default connect(stateToProps, dispatchToProps)(FlowCreateModal)



// WEBPACK FOOTER //
// ./src/features/Flows/FlowCreateModal/FlowCreateModal.container.js